import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Category } from "../types";

type GetCategoriesParams = {
	locale?: string;
};

const fetchCategories = async (locale: string = "en-us"): Promise<Category[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getCategories",
		bind: {
			locale: locale.toLowerCase(),
		},
	});

	return response.data.result;
};

export const useGetCategories = ({ locale }: GetCategoriesParams) => {
	return useQuery<Category[]>({
		queryKey: ["getCategoriesV2", locale],
		queryFn: () => fetchCategories(locale),
		select: (data) => {
			return data;
		},
	});
};
